export { leseCookieWert, ermittleAbholungCta };

// Liest den Wert eines Cookies aus einem Cookie-String (document.cookie). Leer, wenn nicht vorhanden.
function leseCookieWert(cookieString, name) {
  const treffer = (cookieString || "")
    .split(";")
    .map((eintrag) => eintrag.trim())
    .find((eintrag) => eintrag.startsWith(`${name}=`));
  return treffer ? decodeURIComponent(treffer.slice(name.length + 1)) : "";
}

// Ergaenzt die filialId (aus dem Cookie) in der Formular-Action des "Zur Abholung bestellen"-Buttons
// und entscheidet ueber dessen Sichtbarkeit. Steht bereits eine filialId in der Action (z.B. serverseitig
// per URL-Param), bleibt sie unveraendert. Ohne filialId bleibt der Button verborgen. Zusaetzlich bleibt
// der Button verborgen, wenn die Abholaussage der Filiale "nicht verfuegbar" meldet (data-state="negative")
// oder das LieAS-Snippet die Filialabholung ausschliesst (data-filialabholung-moeglich="false"). Fehlt das
// Flag (null/undefined, z.B. Snippet noch nicht geladen), wird es nicht als Ausschluss gewertet.
function ermittleAbholungCta(currentAction, filialId, verfuegbarkeitStatus, filialabholungMoeglich) {
  const nichtVerfuegbar = verfuegbarkeitStatus === "negative";
  const nichtMoeglich = filialabholungMoeglich === false;
  const abholbar = !nichtVerfuegbar && !nichtMoeglich;
  const hatFilialId = /[?&]filialId=/.test(currentAction);
  if (filialId && !hatFilialId) {
    const trenner = currentAction.includes("?") ? "&" : "?";
    return { action: `${currentAction}${trenner}filialId=${encodeURIComponent(filialId)}`, sichtbar: abholbar };
  }
  return { action: currentAction, sichtbar: hatFilialId && abholbar };
}
